import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import './App.css';

// Auth Components
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';

// Dashboard Layout
import DashboardLayout from './components/Layout/DashboardLayout';

// Dashboard Pages
import DashboardPage from './pages/DashboardPage';
import AddProductPage from './pages/AddProductPage';
import ViewProductsPage from './pages/ViewProductsPage';
import ShopifyIntegrationPage from './pages/ShopifyIntegrationPage';
import EbayIntegrationPage from './pages/EbayIntegrationPage';
import PoshmarkIntegrationPage from './pages/PoshmarkIntegrationPage';
import EbaySettingsPage from './pages/EbaySettingsPage';
import ShopifySettingsPage from './pages/ShopifySettingsPage';
import GeneralSettingPage from './pages/GeneralSettingPage';
import InviteUsersPage from './pages/InviteUsersPage';

// ✅ Google Client ID
const GOOGLE_CLIENT_ID = "611740572510-n9ctrclusl3tc1ja253f2ggfg7al7kna.apps.googleusercontent.com";

// =============================================
// PROTECTED ROUTE COMPONENT
// =============================================
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  
  // Check if token exists and is valid (allow test tokens)
  if (!token || token.startsWith('dummy-') || token.startsWith('google-dummy-') || token.startsWith('google-register-')) {
    // Clear any invalid tokens
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // User not logged in, redirect to login
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// =============================================
// PUBLIC ROUTE COMPONENT (Allow access even when logged in)
// =============================================
const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  
  // If we have invalid tokens, clear them
  if (token && (token.startsWith('dummy-') || token.startsWith('google-dummy-') || token.startsWith('google-register-'))) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
  
  return children;
};

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Router>
        <div className="App">
          <Routes>
            {/* ============================================ */}
            {/* PUBLIC ROUTES (Login/Register Only) */}
            {/* ============================================ */}
            <Route 
              path="/" 
              element={<Navigate to="/login" replace />} 
            />
            
            <Route 
              path="/login" 
              element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              } 
            />
            
            <Route 
              path="/register" 
              element={
                <PublicRoute>
                  <RegisterPage />
                </PublicRoute>
              } 
            />

            {/* ============================================ */}
            {/* PROTECTED ROUTES (Dashboard & All Pages) */}
            {/* ============================================ */}
            <Route 
              path="/" 
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              {/* Dashboard Home */}
              <Route path="dashboard" element={<DashboardPage />} />
              
              {/* Products */}
              <Route path="products" element={<ViewProductsPage />} />
              <Route path="products/add" element={<AddProductPage />} />
              
              {/* Integrations */}
              <Route path="integrations/shopify" element={<ShopifyIntegrationPage />} />
              <Route path="integrations/ebay" element={<EbayIntegrationPage />} />
              <Route path="integrations/poshmark" element={<PoshmarkIntegrationPage />} />
              
              {/* Settings */}
              <Route path="settings/ebay" element={<EbaySettingsPage />} />
              <Route path="settings/shopify" element={<ShopifySettingsPage />} />
              <Route path="settings/general" element={<GeneralSettingPage/>}/>
              
              {/* Invite Users */}
              <Route path="invite-users" element={<InviteUsersPage />} />
            </Route>

            {/* ============================================ */}
            {/* 404 - CATCH ALL (Optional) */}
            {/* ============================================ */}
            <Route 
              path="*" 
              element={<Navigate to="/login" replace />} 
            />
          </Routes>
        </div>
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;